import React, { useState } from 'react'
import { TbArrowsUpDown } from 'react-icons/tb'
import { useNavigate } from 'react-router-dom'
import { IFilters } from 'types/configurations'
import { Pagination } from 'components/Pagination'

import {
  FlexTitle,
  iconUpDown,
  TrHtml,
  TableHtml,
  ThreadHtml,
  TableContainer,
  Tbody,
  Td,
  Th,
  Tr,
  Div
} from 'components/SharedTable/styles'
import { filterTextForTable } from './helper'

interface ITableProps {
  titleTable?: any[]
  tableData: any[][]
  selectedFilters?: IFilters
  paginationTotal?: number
  paginationItensByPage?: number
  paginationNumberSelectedPage?: Function
  orderCollumnSelected?: Function
  paginationCurrentPage?: number
}
type TableProps = ITableProps
/**
 * Componente principal para renderizar as tabelas do projeto
 * @param tableData - Array bidimensional estruturado como 1 dimensão os registros e a 2 dimensão os valores
 * @param selectedFilters - Objeto para controle se seleção dos filtros
 * @param titleTable - Array com os objetos que contém o titulo de cada coluna
 * @param paginationTotal - Total de itens mostrados na página
 * @param paginationItensByPage - Numero de itens por página
 * @param paginationNumberSelectedPage - Função que retorna o número da pagina selecionada
 */

const Table = ({ tableData, selectedFilters, titleTable, paginationTotal, paginationItensByPage, paginationNumberSelectedPage, orderCollumnSelected, paginationCurrentPage }: TableProps) => {
  const navigate = useNavigate()
  const [order, setOrder] = useState<string>('ORDERBY')

  const filterMarker = (text: string) => {
    return filterTextForTable(text, selectedFilters)
  }
  /**
   * Resposavel por definir a ordenação por campo selecionado na coluna da Table
   * Controla também o estado do orderBy
   * @param field
   */
  const handleClickOrderBy = (field: string) => {
    let selectedOrder = null
    if (order === 'ORDERBY') {
      selectedOrder = 'ORDERBYDESC'
    } else {
      selectedOrder = 'ORDERBY'
    }
    setOrder(selectedOrder)
    orderCollumnSelected({ field: field, order: selectedOrder })
  }

  /**
   * Usado para tratar a informação impressa no conteúdo de cada coluna da tabela
   * @param content 
   * @param index 
   */
  const tableContent = (content: any, index: number) => {
    if (index === 1) {
      return (<span>
        {content &&
          filterMarker?.(content)
            .split('<span')
            .map((part, index) =>
              index === 0 ? (
                <React.Fragment key={index}>
                  {part}
                </React.Fragment>
              ) : (
                <span
                  key={index}
                  dangerouslySetInnerHTML={{
                    __html: `<span${part}`,
                  }}
                />
              )
            )}
      </span>)

    } else {
      return (<>{content}</>)
    }
  }

  return (
    <>
      <Div className='flex flex-col mb-6'>
        <Div className='overflow-x-auto'>
          <Div className='inline-block min-w-full'>
            <TableContainer>
              <TableHtml>
                <ThreadHtml className='bg-tableTitleBg h-[39px]'>
                  <TrHtml className='divide-x divide-gray-200 h-[39px]'>
                    {titleTable.map((title, index) => (
                      <Th key={index} scope='col'>
                        <FlexTitle>
                          {title.name}
                          {title.sort ? (
                            <TbArrowsUpDown className={iconUpDown} onClick={(e: any) => handleClickOrderBy(title.field)} />
                          ) : null}
                        </FlexTitle>
                      </Th>
                    ))}
                  </TrHtml>
                </ThreadHtml>
                <Tbody>
                  {tableData.map((data: any, indexReg: any) => {
                    return (
                      <>
                        <Tr key={data} id={`line-${indexReg}`} onClick={() => typeof data[0] === 'string' ? navigate(data.find((e: any) => !!e)) : (() => false)()} >
                          {data.map((col: any, indexProp: number) => {
                            if (indexProp !== 0) return (<Td className='w-[147px]'>{tableContent(col, indexProp)}</Td>)
                          })}
                        </Tr>
                      </>
                    )
                  }
                  )}
                </Tbody>
              </TableHtml>
            </TableContainer>
          </Div>
        </Div>
      </Div>

      <Pagination
        paginationTotal={paginationTotal}
        paginationItensByPage={paginationItensByPage}
        paginationNumberSelectedPage={paginationNumberSelectedPage}
        paginationCurrentPage={paginationCurrentPage}
        tableSize={tableData.length}
      />

    </>
  )
}

export default Table